/* eslint-disable react/require-default-props */
import { OutlinedInput, OutlinedInputProps } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useController } from 'react-hook-form';
import { useFieldControllerContext } from './FieldControllerContext';
import { fieldHasError } from './formUtils';

export type FieldOutlinedInputProps = OutlinedInputProps & {
  maxLength?: number;
  noNegativeNumbers?: boolean;
};

const FieldOutlinedInput: React.FC<FieldOutlinedInputProps> = ({
  onChange,
  onBlur,
  maxLength,
  inputProps,
  noNegativeNumbers = false,
  ...props
}) => {
  const { name, control, inputLabel, setMaxLength } =
    useFieldControllerContext();
  const {
    fieldState,
    field: { ref, value, onBlur: onFieldBlur, onChange: onFieldChange },
  } = useController({ name, control });

  useEffect(() => {
    if (maxLength) setMaxLength(maxLength);
  }, [maxLength, setMaxLength]);

  return (
    <OutlinedInput
      id={name}
      name={name}
      inputRef={ref}
      label={inputLabel}
      onBlur={ev => {
        onBlur?.(ev);
        onFieldBlur();
      }}
      // eslint-disable-next-line consistent-return
      onChange={ev => {
        const inputValue = ev.target.value;
        const isNegativeNumber =
          props?.type === 'number' &&
          noNegativeNumbers &&
          Number(inputValue) < 0;

        if (isNegativeNumber) return ev.preventDefault();

        onChange?.(ev);
        onFieldChange(ev);
      }}
      value={value}
      error={fieldHasError(fieldState)}
      aria-describedby={`${name}-helper-text`}
      inputProps={{ maxLength, ...inputProps }}
      {...props}
    />
  );
};

export default FieldOutlinedInput;
